import { CompanyBase, InfoExt, UserBase, UserProfileBase } from 'base-models';

/**
 * Enum with the resource id of the control/section or whatelse we want to be controlled
 */
var ControlEnum;
(function (ControlEnum) {
    ControlEnum["BTN_ADMINISTRATOR"] = "BTN_ADMINISTRATOR";
    ControlEnum["BTN_SITE_NEW"] = "BTN_SITE_NEW";
    ControlEnum["BTN_SITE_EDIT"] = "BTN_SITE_EDIT";
    ControlEnum["BTN_SITE_DELETE"] = "BTN_SITE_DELETE";
    ControlEnum["BTN_SUPERVISION_EXPORT_EXCEL"] = "BTN_SUPERVISION_EXPORT_EXCEL";
    ControlEnum["BTN_SUPERVISION_EXPORT_PDF"] = "BTN_SUPERVISION_EXPORT_PDF";
    ControlEnum["SEC_SITE_DASHBOARD"] = "SEC_SITE_DASHBOARD";
    ControlEnum["BTN_ADMIN_USERS"] = "BTN_ADMIN_USERS";
    ControlEnum["BTN_SUPERVISION_EDIT"] = "BTN_SUPERVISION_EDIT";
    ControlEnum["SEC_DASHBOARD"] = "SEC_DASHBOARD";
    ControlEnum["SEC_DASHBOARD_COMPARER"] = "SEC_DASHBOARD_COMPARER";
    ControlEnum["SEC_SITE"] = "SEC_SITE";
    ControlEnum["SEC_SUPERVISION"] = "SEC_SUPERVISION";
    ControlEnum["SEC_ADMIN"] = "SEC_ADMIN";
    ControlEnum["SUPERVISION_READ"] = "SUPERVISION_READ";
    ControlEnum["SUPERVISION_CHANGE_STATUS"] = "SUPERVISION_CHANGE_STATUS";
    ControlEnum["SUPERVISION_VALIDATOR"] = "SUPERVISION_VALIDATOR";
    ControlEnum["SUPERVISION_SHOWISSUEONCANVAS"] = "SUPERVISION_SHOWISSUEONCANVAS";
    ControlEnum["SEC_SUPERV_VALIDATOR"] = "SEC_SUPERV_VALIDATOR";
    ControlEnum["SEC_FLIGHT_OPERATOR"] = "SEC_FLIGHT_OPERATOR";
    ControlEnum["BTN_FLIGHT_NEW"] = "BTN_FLIGHT_NEW";
    ControlEnum["BTN_FLIGHT_UPLOADIMAGES"] = "BTN_FLIGHT_UPLOADIMAGES";
    ControlEnum["BTN_FLIGHT_PROCESS_IMAGES"] = "BTN_FLIGHT_PROCESS_IMAGES";
    ControlEnum["BTN_FLIGHT_PROCESS_ISSUES"] = "BTN_FLIGHT_PROCESS_ISSUES";
    ControlEnum["BTN_FLIGHT_OPERATOR"] = "BTN_FLIGHT_OPERATOR";
    ControlEnum["BTN_FLIGHT_VALIDATOR"] = "BTN_FLIGHT_VALIDATOR";
    ControlEnum["BTN_SUPERV_VALIDATOR"] = "BTN_SUPERV_VALIDATOR";
    ControlEnum["MAP_FLIGHT_IMAGES_LAYER"] = "MAP_FLIGHT_IMAGES_LAYER";
})(ControlEnum || (ControlEnum = {}));

/**
 * App profiles
 */
var ProfileEnum;
(function (ProfileEnum) {
    /* DIOS = "DIOS", */
    ProfileEnum["SYSTEM_DEV"] = "SYSTEM_DEV";
    ProfileEnum["ADMINISTRATOR"] = "ADMINISTRATOR";
    ProfileEnum["SITE_NEW"] = "SITE_NEW";
    ProfileEnum["SITE_EDIT"] = "SITE_EDIT";
    ProfileEnum["SITE_READ"] = "SITE_READ";
    ProfileEnum["SITE_DELETE"] = "SITE_DELETE";
    ProfileEnum["SITE_DASHBOARD"] = "SITE_DASHBOARD";
    ProfileEnum["DASHBOARD"] = "DASHBOARD";
    ProfileEnum["DASHBOARD_COMPARER"] = "DASHBOARD_COMPARER";
    ProfileEnum["SUPERVISION_EDIT"] = "SUPERVISION_EDIT";
    ProfileEnum["SUPERVISION_VALIDATOR"] = "SUPERVISION_VALIDATOR";
    ProfileEnum["SUPERVISION_READ"] = "SUPERVISION_READ";
    ProfileEnum["SUPERVISION_DELETE"] = "SUPERVISION_DELETE";
    ProfileEnum["SUPERVISION_EXPORT_EXCEL"] = "SUPERVISION_EXPORT_EXCEL";
    ProfileEnum["SUPERVISION_EXPORT_PDF"] = "SUPERVISION_EXPORT_PDF";
    ProfileEnum["FLIGHT_OPERATOR"] = "FLIGHT_OPERATOR";
    ProfileEnum["FLIGHT_VALIDATOR"] = "FLIGHT_VALIDATOR";
    ProfileEnum["CERTUSER"] = "CERTUSER";
    ProfileEnum["ADMIN_USERS"] = "ADMIN_USERS";
    ProfileEnum["NOTIF_RESPONSIBLE_SITE"] = "NOTIF_RESPONSIBLE_SITE";
    ProfileEnum["NOTIF_RESPONSIBLE_SUPERVISION"] = "NOTIF_RESPONSIBLE_SUPERVISION";
    ProfileEnum["NOTIF_RESPONSIBLE_OPERATIONS"] = "NOTIF_RESPONSIBLE_OPERATIONS";
    ProfileEnum["VERIFIER_SITE_EDIT"] = "VERIFIER_SITE_EDIT";
    ProfileEnum["OM_READ"] = "OM_READ";
    ProfileEnum["OM_EDIT"] = "OM_EDIT";
})(ProfileEnum || (ProfileEnum = {}));

/**
 * 1-Descargar del servidor los roles del usuario
 * 2-Descargar los controles y sus roles
 * Opcion 1
 * 3-Al cargar el control comprobar si el usuario tiene el rol. Esto es dinamico
 * Opcion 2 configurar un array con la visibilidad/status de los botones al hacer login
 * , más eficiente ya que no tiene que iterar por sub arrays aunque ni se notaria que es como esta actualmente.
 * 3-Configurar array con el status de los controles...(Tambien se puede descargar del servidor el array)
 */
const appcontrols = [
    { resourceId: ControlEnum.BTN_ADMINISTRATOR, roles: [ProfileEnum.ADMINISTRATOR] },
    { resourceId: ControlEnum.BTN_SITE_NEW, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.SITE_EDIT] },
    { resourceId: ControlEnum.BTN_SITE_EDIT, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.SITE_EDIT] },
    { resourceId: ControlEnum.BTN_SITE_DELETE, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.SITE_DELETE] },
    { resourceId: ControlEnum.BTN_SUPERVISION_EXPORT_EXCEL, roles: [ProfileEnum.SUPERVISION_EXPORT_EXCEL] },
    { resourceId: ControlEnum.BTN_SUPERVISION_EXPORT_PDF, roles: [ProfileEnum.SUPERVISION_EXPORT_PDF] },
    { resourceId: ControlEnum.BTN_SUPERVISION_EDIT, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.SITE_EDIT, ProfileEnum.SUPERVISION_EDIT] },
    { resourceId: ControlEnum.SEC_DASHBOARD, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.DASHBOARD] },
    { resourceId: ControlEnum.SEC_SITE_DASHBOARD, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.SITE_DASHBOARD] },
    { resourceId: ControlEnum.SEC_DASHBOARD_COMPARER, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.DASHBOARD_COMPARER, ProfileEnum.SITE_EDIT, ProfileEnum.SITE_READ, ProfileEnum.SUPERVISION_EDIT, ProfileEnum.SUPERVISION_READ] },
    { resourceId: ControlEnum.SEC_SITE, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.SITE_EDIT, ProfileEnum.SITE_READ] },
    { resourceId: ControlEnum.SEC_SUPERVISION, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.SITE_EDIT, ProfileEnum.SUPERVISION_EDIT, ProfileEnum.SUPERVISION_READ, ProfileEnum.OM_EDIT, ProfileEnum.OM_READ] },
    { resourceId: ControlEnum.SEC_ADMIN, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.ADMIN_USERS] },
    { resourceId: ControlEnum.BTN_ADMIN_USERS, roles: [ProfileEnum.ADMINISTRATOR, ProfileEnum.ADMIN_USERS] },
    { resourceId: ControlEnum.SEC_SUPERV_VALIDATOR, roles: [ProfileEnum.SUPERVISION_VALIDATOR] },
    { resourceId: ControlEnum.SEC_FLIGHT_OPERATOR, roles: [ProfileEnum.FLIGHT_OPERATOR, ProfileEnum.SUPERVISION_VALIDATOR, ProfileEnum.FLIGHT_VALIDATOR] },
    { resourceId: ControlEnum.MAP_FLIGHT_IMAGES_LAYER, roles: [ProfileEnum.FLIGHT_OPERATOR, ProfileEnum.SUPERVISION_VALIDATOR, ProfileEnum.FLIGHT_VALIDATOR] },
    { resourceId: ControlEnum.BTN_FLIGHT_NEW, roles: [ProfileEnum.FLIGHT_OPERATOR] },
    { resourceId: ControlEnum.BTN_FLIGHT_UPLOADIMAGES, roles: [ProfileEnum.FLIGHT_OPERATOR] },
    { resourceId: ControlEnum.BTN_FLIGHT_PROCESS_IMAGES, roles: [ProfileEnum.FLIGHT_VALIDATOR] },
    { resourceId: ControlEnum.BTN_FLIGHT_PROCESS_ISSUES, roles: [ProfileEnum.FLIGHT_VALIDATOR] },
    { resourceId: ControlEnum.BTN_FLIGHT_OPERATOR, roles: [ProfileEnum.FLIGHT_OPERATOR] },
    { resourceId: ControlEnum.BTN_FLIGHT_VALIDATOR, roles: [ProfileEnum.FLIGHT_VALIDATOR] },
    { resourceId: ControlEnum.SUPERVISION_CHANGE_STATUS, roles: [ProfileEnum.SUPERVISION_VALIDATOR] },
    { resourceId: ControlEnum.SUPERVISION_VALIDATOR, roles: [ProfileEnum.SUPERVISION_VALIDATOR] },
    { resourceId: ControlEnum.SUPERVISION_SHOWISSUEONCANVAS, roles: [ProfileEnum.SYSTEM_DEV] }
    /*   , { resourceId: 'BACK_SITE_EDIT', roles: [ProfileEnum.SITE_EDIT] }
      , { resourceId: 'BACK_FLIGHT_CREATE', roles: [ProfileEnum.ADMINISTRATOR] }
      , { resourceId: 'BACK_FLIGHT_UPDATE', roles: [ProfileEnum.SITE_EDIT] }
      , { resourceId: 'BACK_FLIGHT_DELETE', roles: [ProfileEnum.SITE_EDIT] }
      , { resourceId: 'BACK_FLIGHT_READ', roles: [ProfileEnum.SITE_EDIT] } */
];

/**
 * System roles to be selected for users
 * This must or can be downloaded from server
 */
class SystemRoles {
}
SystemRoles.roles = [
    { id: ProfileEnum.ADMINISTRATOR, name: 'Administrator' },
    { id: ProfileEnum.ADMIN_USERS, name: 'Admin Users', comments: 'Can create and edit users' },
    { id: ProfileEnum.DASHBOARD, name: 'Company DashBoard' },
    /* { id: ProfileEnum.DASHBOARD_COMPARER, name: 'Site DashBoard Comparer ' }, */
    { id: ProfileEnum.SITE_READ, name: 'Site Viewer' },
    { id: ProfileEnum.SITE_EDIT, name: 'Site Edition' },
    { id: ProfileEnum.SITE_DELETE, name: 'Site Delete' },
    { id: ProfileEnum.SUPERVISION_EDIT, name: 'Supervision Edition' },
    { id: ProfileEnum.SUPERVISION_READ, name: 'Supervision Viewer' },
    { id: ProfileEnum.SUPERVISION_VALIDATOR, name: 'Supervision Validator', comments: 'Can validate all supervision aspects' },
    { id: ProfileEnum.FLIGHT_OPERATOR, name: 'Flight operator', comments: 'Can make flights and upload files' },
    { id: ProfileEnum.FLIGHT_VALIDATOR, name: 'Flight validator', comments: 'Can validate flights' },
    { id: ProfileEnum.OM_EDIT, name: 'O&M edition', comments: 'Can create and modify maintenance operations' },
    { id: ProfileEnum.OM_READ, name: 'O&M reader', comments: 'Can see maintenance operations' },
];

var UploadTypeEnum;
(function (UploadTypeEnum) {
    UploadTypeEnum["flight"] = "flight";
    UploadTypeEnum["flight_thermal"] = "flight_thermal";
    UploadTypeEnum["flight_thermal_rjpeg"] = "flight_thermal_rjpeg";
    UploadTypeEnum["flight_rgb"] = "flight_rgb";
    UploadTypeEnum["site_radiation_data"] = "site_radiation_data";
    UploadTypeEnum["supervision_info"] = "supervision_info";
    UploadTypeEnum["site_info"] = "site_info";
    UploadTypeEnum["site_photo"] = "site_photo";
    UploadTypeEnum["user_photo"] = "user_photo";
    UploadTypeEnum["user_info"] = "user_info";
})(UploadTypeEnum || (UploadTypeEnum = {}));

/**
 * Supervision status enum
 */
var CompanyTypeEnum;
(function (CompanyTypeEnum) {
    CompanyTypeEnum["STD"] = "STD";
    CompanyTypeEnum["VERIFIER"] = "VERIFIER";
    CompanyTypeEnum["FLIGHTER"] = "FLIGHTER";
})(CompanyTypeEnum || (CompanyTypeEnum = {}));

class Company extends CompanyBase {
    static getCompanyType(company) {
        if (!company.info) {
            return CompanyTypeEnum.STD;
        }
        else if (company.info.company_type) {
            let company_type = company.info.company_type;
            if (company_type === "VERIFIER") {
                return CompanyTypeEnum.VERIFIER;
            }
        }
        return CompanyTypeEnum.STD;
    }
}

class ErrorPanelType {
}

class Flight {
    constructor() {
        this.info = new InfoFlight();
    }
}
class InfoFlight extends InfoExt {
    constructor() {
        super(...arguments);
        this.offset_x = 0;
        this.offset_y = 0;
        this.offset_z = 0;
        this.temperature_offset = 0;
        this.temperature_low = -9999;
        this.temperature_high = +9999;
        this.offset_camera_yaw = 0;
        this.offset_camera_pitch = 0;
        this.offset_camera_roll = 0;
        this.max_RelativeAlt = 0;
        this.min_RelativeAlt = 0;
    }
}

var FlightStatusEnum;
(function (FlightStatusEnum) {
    FlightStatusEnum["NONE"] = "NONE";
    FlightStatusEnum["FLIGHT_CREATED"] = "FLIGHT_CREATED";
    FlightStatusEnum["FLIGHT_LOADING_FILES"] = "FLIGHT_LOADING_FILES";
    FlightStatusEnum["FLIGHT_LOADING_FILES_ERROR"] = "FLIGHT_LOADING_FILES_ERROR";
    FlightStatusEnum["FLIGHT_FILE_PROCESS_PENDING"] = "FLIGHT_FILE_PROCESS_PENDING";
    FlightStatusEnum["FLIGHT_FILE_PROCESSING"] = "FLIGHT_FILE_PROCESSING";
    FlightStatusEnum["FLIGHT_FILE_PROCESSING_ERROR"] = "FLIGHT_FILE_PROCESSING_ERROR";
    FlightStatusEnum["FLIGHT_ISSUES_PROCESS_PENDING"] = "FLIGHT_ISSUES_PROCESS_PENDING";
    FlightStatusEnum["FLIGHT_ISSUES_PROCESSING"] = "FLIGHT_ISSUES_PROCESSING";
    FlightStatusEnum["FLIGHT_ISSUES_PROCESSING_ERROR"] = "FLIGHT_ISSUES_PROCESSING_ERROR";
    FlightStatusEnum["FLIGHT_READY"] = "FLIGHT_READY";
})(FlightStatusEnum || (FlightStatusEnum = {}));

class FrGeometry {
    constructor() {
        this.type = "Polygon";
    }
}

var IssueType;
(function (IssueType) {
    IssueType["TOCXS"] = "TOCXS";
    IssueType["E1PC"] = "1PC";
    IssueType["PCS"] = "PCS";
    IssueType["E1CC"] = "1CC";
    IssueType["CCS"] = "CCS";
    IssueType["SMC"] = "SMC";
    IssueType["PID"] = "PID";
    IssueType["DRT"] = "DRT";
    IssueType["SDW"] = "SDW";
    IssueType["FUS"] = "FUS";
    IssueType["BRK"] = "BRK";
    IssueType["DSC"] = "DSC";
    IssueType["NDM"] = "NDM";
    IssueType["UNK"] = "UNK";
    IssueType["CBOX"] = "CBOX";
    IssueType["IPO"] = "IPO";
    IssueType["DBB"] = "DBB";
    IssueType["DLM"] = "DLM";
    IssueType["SHC"] = "SHC";
    IssueType["NOERROR"] = "NOERROR";
})(IssueType || (IssueType = {}));
/*
    UNK='UNK',
    CBOX='CBOX',
    IPO='IPO',
    DBB='DBB',
    DLM='DLM',


other=violeta
String=1, red
Cell=2, yellow
CellMulti orange
Cracking=3, green
Diode=4, gris
DiodeMulti=5, gris claro

filter
cell
cell high
cell medium
cell Multi
cell Multi high
cell Multi medium
cracking
diode
linked image
shadowing
string
*/

class IssueImage {
}

/**
 * Class used in gallery
 */
class ImageItem {
}
class ImageItemTag {
}

class DB_filter {
    /**
     *
     * @param filter
     * @param values Now is matlistoption, esto hay que cambiarlo
     */
    constructor(filter, values) {
        this.value = [];
        this.filter = filter;
        if (values) {
            for (let elem of values) {
                this.value.push(elem.value);
            }
        }
    }
    static newFilterByArray(filter, values) {
        let df = new DB_filter(filter, null);
        if (values) {
            for (let elem of values) {
                df.value.push(elem);
            }
        }
        return df;
    }
}
/**
 * Supervision status enum
 */
var DBColumnsEnum;
(function (DBColumnsEnum) {
    DBColumnsEnum["site_id"] = "site_id";
    DBColumnsEnum["id_supervision"] = "id_supervision";
    DBColumnsEnum["issue_type"] = "issue_type";
    DBColumnsEnum["relevance"] = "relevance";
    DBColumnsEnum["panel_model"] = "panel_model";
    DBColumnsEnum["panel_brand"] = "panel_brand";
    DBColumnsEnum["issue_status"] = "status";
})(DBColumnsEnum || (DBColumnsEnum = {}));

var OlObjectTypeEnum;
(function (OlObjectTypeEnum) {
    OlObjectTypeEnum[OlObjectTypeEnum["issue"] = 1] = "issue";
    OlObjectTypeEnum[OlObjectTypeEnum["site"] = 2] = "site";
    OlObjectTypeEnum[OlObjectTypeEnum["panel"] = 3] = "panel";
    OlObjectTypeEnum[OlObjectTypeEnum["flightimageproj"] = 4] = "flightimageproj";
})(OlObjectTypeEnum || (OlObjectTypeEnum = {}));

class Panel {
    constructor() {
        this.info = new InfoPanel();
    }
    get geom() {
        return this.geometry;
    }
    set geom(value) {
        this.geometry = value;
    }
    get locator() {
        return this.mlocator;
    }
    set locator(value) {
        this.mlocator = value;
    }
    /**
     * Compare two locators
     * @param a
     * @param b
     */
    static locatorIsEqual(a, b) {
        let a_props = Object.getOwnPropertyNames(a);
        if (b == null) {
            return false;
        }
        for (let aprop of a_props) {
            let af = a[aprop];
            let bf = b[aprop];
            if (bf) {
                if (af != bf) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        return true;
    }
    /**
     * Return panel name with pattern
     * @param panel
     * @param pattern
     */
    static uiLocatorByPanel(panel, pattern) {
        try {
            if (panel) {
                if (!pattern) {
                    //return "No pattern configured in site.";
                    return panel.name;
                }
                let props = Object.getOwnPropertyNames(panel.locator);
                for (let prop of props) {
                    pattern = pattern.replace("[" + prop + "]", panel.locator[prop]);
                }
                return pattern;
            }
            else {
                return "No locator exist. Contact administrator.";
            }
        }
        catch (err) {
            return "Problem with panel locator. Contact administrator.";
        }
    }
}
class InfoPanel extends InfoExt {
}

class PanelType {
}
/*
{"id":"1fbb4d3c-8877-11ea-92bb-509a4c837ab7","brand":"Siliken","model":"SLK60P6L-225","serial":"","type":"POLY-SI"
,"mechanical":{"D":40,"H":1640,"W":990}
,"electrical":{"Imp":7.68,"Isc":8.2,"Vmp":29.3,"Voc":36.8,"power":225,"efficency":13.9}
,"certification":{"CE Mark":"yes","ISO 14001":"ES09/6520","UL Listed":"UL 1703"
,"datasheet":"http://www.coloradosolarpower.net/images/brochures/p100094/SLK60P6L%20SLV-WHT_US%20051311.pdf"
,"Fire Rating":"Class C","ISO 9001:2000":"ES08/5170"},"operational":{"Load":{"max":5400,"units":"Pa","static":2400}
,"Temperature":{"max":85,"min":-40}}
,"info":{"datasheet":"http://www.coloradosolarpower.net/images/brochures/p100094/SLK60P6L%20SLV-WHT_US%20051311.pdf"}}


*/

class SolarErr {
}
SolarErr.ERR_LOAD_SUPERVISION = "ERR_LOAD_SUPERVISION";
SolarErr.ERR_LOAD_PANELSTYPE = "ERR_LOAD_PANELSTYPE";
SolarErr.ERR_LOAD_PANELS = "ERR_LOAD_PANELS";
SolarErr.ERR_LOAD_ISSUES = "ERR_LOAD_ISSUES";

class Site {
    constructor() {
        this.info = new InfoSite();
        this.contacts = [];
        /**
         * permissions that this company has.
         * todo: When this is empty we can assume than is the owner??? Or set all checking owner id
         */
        this.permissions = [];
    }
    static getPanelPattern(site, pattern) {
        let panel_locator_pattern = "";
        if (site && site.info && site.info.panel_locator_pattern) {
            let plp = site.info.panel_locator_pattern;
            let usePattern = true;
            if (plp.hasOwnProperty('usepattern')) {
                usePattern = plp.usepattern;
            }
            if (usePattern) {
                panel_locator_pattern = plp[pattern];
                return panel_locator_pattern;
            }
            else {
                return "";
            }
        }
        else {
            return "";
        }
    }
}
class InfoSite extends InfoExt {
    /**
     * Usar esta propiedad para en el futuro no usar countryfull sino un servicio o similar
     */
    get countryFull2() {
        return this.countryFull;
    }
    set countryFull2(value) {
        this.countryFull = value;
    }
}
class PanelLocatorPattern {
}

class CacheSitePanels {
}

/**
 * Supervision status enum
 */
var SupervisionStatusEnum;
(function (SupervisionStatusEnum) {
    SupervisionStatusEnum["OPEN"] = "OPEN";
    SupervisionStatusEnum["CREATED"] = "CREATED";
    SupervisionStatusEnum["LOADING"] = "LOADING_FILES";
    SupervisionStatusEnum["INPROCESS"] = "PROCESSING";
    SupervisionStatusEnum["READYTOVALIDATE"] = "READY_TO_VALIDATE";
    SupervisionStatusEnum["VALIDATED"] = "VALIDATED";
    SupervisionStatusEnum["TOVALIDATE"] = "VALIDATION_PENDING";
    SupervisionStatusEnum["DISCARDED"] = "DISCARDED";
    SupervisionStatusEnum["LOCKED"] = "LOCKED";
})(SupervisionStatusEnum || (SupervisionStatusEnum = {}));

class Supervision {
    constructor() {
        this.info = new InfoSupervis();
        this.issues = [];
    }
}
class InfoSupervis extends InfoExt {
    constructor() {
        super(...arguments);
        this.reports = [];
        this.status = SupervisionStatusEnum.OPEN;
    }
}
class SupervisionReports {
}

var SupervisionErrorStatusEnum;
(function (SupervisionErrorStatusEnum) {
    SupervisionErrorStatusEnum[SupervisionErrorStatusEnum["none"] = -1] = "none";
    SupervisionErrorStatusEnum[SupervisionErrorStatusEnum["tovalidate"] = 0] = "tovalidate";
    SupervisionErrorStatusEnum[SupervisionErrorStatusEnum["validated"] = 2] = "validated";
    SupervisionErrorStatusEnum[SupervisionErrorStatusEnum["noerror"] = 3] = "noerror";
    SupervisionErrorStatusEnum[SupervisionErrorStatusEnum["errorchanged"] = 4] = "errorchanged";
    SupervisionErrorStatusEnum[SupervisionErrorStatusEnum["tocheck"] = 5] = "tocheck";
    SupervisionErrorStatusEnum[SupervisionErrorStatusEnum["repeated"] = 6] = "repeated";
})(SupervisionErrorStatusEnum || (SupervisionErrorStatusEnum = {}));

/**
 * Class used for issues. Some fields are unnecesary but used by backend
 */
class SupervisionError {
    constructor() {
        this.info = new InfoIssue();
    }
    //TODO:RELLENAR LOS DATOS NECESARIOS
    get om() {
        return this.info.om;
    }
    set om(value) {
        this.info.om = value;
    }
    /**
     * return locator based on pattern
     * @param row
     * @param pattern
     */
    static uiLocator(row, pattern) {
        try {
            if (row && row.info && row.info.panel) {
                let panel = row.info.panel;
                return SupervisionError.uiLocatorByPanel(panel, pattern);
            }
            else {
                return "No panel exist. Contact administrator.";
            }
        }
        catch (err) {
            return "There is a problem with panel locator. Contact administrator.";
        }
    }
    /**
     * Return panel name with pattern
     * @param panel
     * @param pattern
     */
    static uiLocatorByPanel(panel, pattern) {
        return Panel.uiLocatorByPanel(panel, pattern);
    }
    /**
     * Show the description of an issue
     * @param issue
     */
    static ui_errortype(issue) {
        if (!issue) {
            return "";
        }
        let res = "";
        const st = issue.type;
        if (st === IssueType.TOCXS) {
            res = "All";
        }
        else if (st === IssueType.E1PC) {
            res = "Hot Spot";
        }
        else if (st === IssueType.PCS) {
            res = "Several hot spots";
        }
        else if (st === IssueType.E1CC) {
            res = "Hot cell";
        }
        else if (st === IssueType.CCS) {
            res = "Several hot cells";
        }
        else if (st === IssueType.SMC) {
            res = "Bypass diode";
        }
        else if (st === IssueType.PID) {
            res = "Potencial-induced degradation";
        }
        else if (st === IssueType.DRT) {
            res = "Dirty panel";
        }
        else if (st === IssueType.SDW) {
            res = "Shades";
        }
        else if (st === IssueType.FUS) {
            res = "Melted fuses";
        }
        else if (st === IssueType.BRK) {
            res = "Broken panel";
        }
        else if (st === IssueType.DSC) {
            res = "Disconnected panel";
        }
        else if (st === IssueType.NDM) {
            res = "Flawless Plate";
        }
        else if (st === IssueType.CBOX) {
            res = "Box";
        }
        else if (st === IssueType.DBB) {
            res = "DBB";
        }
        else if (st === IssueType.DLM) {
            res = "Delamination";
        }
        else if (st === IssueType.SHC) {
            res = "Short circuit";
        }
        else if (st === IssueType.IPO) {
            res = "IPO";
        }
        else if (st === IssueType.UNK) {
            res = "Unknown";
        }
        else if (st === IssueType.NOERROR) {
            res = "No Error";
        }
        else {
            res = "Unknown";
        }
        return res;
    }
    forLog() {
        let _se = this;
        let str = JSON.stringify(_se);
        return str;
    }
}
class InfoIssue extends InfoExt {
    constructor() {
        super(...arguments);
        /**
         * Mark issue as errorchanged or noerror
         */
        this.statusType = SupervisionErrorStatusEnum.none;
        /**
         * Mark issue as repeated
         */
        this.issueRepeated = false;
    }
}
class SubIssue {
}

class SupervConstants {
}
SupervConstants.ISSUE_ADDED = "ISSUE_ADDED";
SupervConstants.ISSUE_SAVED = "ISSUE_SAVED";
SupervConstants.ISSUE_PANEL_MODIFIED = "ISSUE_PANEL_MODIFIED";
SupervConstants.ISSUE_PANEL_REMOVE = "ISSUE_PANEL_REMOVE";
SupervConstants.ISSUE_EDIT_IMAGE_CHANGE = "ISSUE_EDIT_IMAGE_CHANGE";
SupervConstants.ISSUE_ADD_FROM_IMAGE = "ISSUE_ADD_FROM_IMAGE";

class ThermalTemp {
}

class User extends UserBase {
    constructor() {
        super(...arguments);
        /**
         * Show/hide verifier logo
         */
        this.showverifierlogo = false;
        /**
         * allow user view log options
         */
        this.showlogtrace = false;
    }
    static configObject(source, appcontrols) {
        let objUser = new User();
        Object.assign(objUser, source.user);
        objUser.token = source.token;
        if (!objUser.profile) {
            objUser.profile = new UserProfileBase();
        }
        else if (!objUser.profile.hasOwnProperty("access_level")) {
            objUser.profile = new UserProfileBase();
        }
        objUser.profile.access_level.push(source.user.info.access_level);
        if (!objUser.resourceList) {
            User.configControlAccess(objUser, appcontrols); //todo:eliminar cuando la lista venga llena del servidor
        }
        User.configEntitiesAccessList(objUser);
        //console.log("auth response", source.user);
        //console.log("auth response token object", source.token);
        //console.log(obj.fullname());
        return objUser;
    }
    static configEntitiesAccessList(user) {
        let obj = user;
        if (obj.info && obj.info.sites) {
            for (let site of obj.info.sites) {
                let acl = site.company_acl;
                if (acl && acl.access_level) {
                    user.entities_acl.push({ id: site.id, acl: acl.access_level });
                }
            }
        }
        console.log("User access list acl", user.entities_acl);
    }
}

class UserProfile extends UserProfileBase {
}

/**
 * list of roles to show for verifier type company
 */
class Verifier_UserRoles {
}
Verifier_UserRoles.roles = [
    { id: ProfileEnum.ADMINISTRATOR, name: 'Administrator' },
    { id: ProfileEnum.ADMIN_USERS, name: 'Admin Users' },
    { id: ProfileEnum.CERTUSER, name: 'Certification user' },
    { id: ProfileEnum.DASHBOARD, name: 'Company DashBoard' },
    /* { id: ProfileEnum.DASHBOARD_COMPARER, name: 'Site DashBoard Comparer ' }, */
    { id: ProfileEnum.SITE_READ, name: 'Site Viewer' },
    { id: ProfileEnum.VERIFIER_SITE_EDIT, name: 'Site Edition' },
    { id: ProfileEnum.SUPERVISION_EDIT, name: 'Supervision Edition' },
    { id: ProfileEnum.SUPERVISION_READ, name: 'Supervision Viewer' },
    { id: ProfileEnum.SUPERVISION_VALIDATOR, name: 'Supervision Validator', comments: 'Can validate all supervision aspects' },
    { id: ProfileEnum.FLIGHT_OPERATOR, name: 'Flight operator', comments: 'Can make flights and upload files' },
    { id: ProfileEnum.FLIGHT_VALIDATOR, name: 'Flight validator', comments: 'Can validate flights' },
];
/**
 * used in verifier detail  component, but not used now
 * Roles that clients give to verifies
 */
class VerifierRoles {
}
VerifierRoles.roles = [
    /* { id: ProfileEnum.DASHBOARD_COMPARER, name: 'Site DashBoard Comparer ' }, */
    { id: ProfileEnum.SITE_READ, name: 'Site Viewer' },
    { id: ProfileEnum.SITE_EDIT, name: 'Site Edition' },
    { id: ProfileEnum.SUPERVISION_EDIT, name: 'Supervision Edition' },
    { id: ProfileEnum.SUPERVISION_READ, name: 'Supervision Viewer' },
    { id: ProfileEnum.FLIGHT_OPERATOR, name: 'Flight operator' },
];

/**
 * token to inject service by name
 */
const ISSUE_IMAGE_BASE_DIR_TOKEN = 'ISSUE_IMAGE_BASE_DIR_TOKEN';
const ISSUE_IMAGE_BASE_DIR_TOKEN_DEFAULT = {
    baseUrl: ""
};

class AppSharedConfig {
}
AppSharedConfig.issueimagebasedir = '';

/*
 * Public API Surface of solar-bo
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppSharedConfig, CacheSitePanels, Company, CompanyTypeEnum, ControlEnum, DBColumnsEnum, DB_filter, ErrorPanelType, Flight, FlightStatusEnum, FrGeometry, ISSUE_IMAGE_BASE_DIR_TOKEN, ISSUE_IMAGE_BASE_DIR_TOKEN_DEFAULT, ImageItem, ImageItemTag, InfoFlight, InfoIssue, InfoPanel, InfoSite, InfoSupervis, IssueImage, IssueType, OlObjectTypeEnum, Panel, PanelLocatorPattern, PanelType, ProfileEnum, Site, SolarErr, SubIssue, SupervConstants, Supervision, SupervisionError, SupervisionErrorStatusEnum, SupervisionReports, SupervisionStatusEnum, SystemRoles, ThermalTemp, UploadTypeEnum, User, UserProfile, VerifierRoles, Verifier_UserRoles, appcontrols };
//# sourceMappingURL=solar-bo.js.map
